import controller from 'core/controllerPlans'
import once from 'utils/functional/once'
import 'bootstrap/js/src/modal'
import initDOM from './initDOM'
import 'bootstrap/js/src/tab'
import config from './config'
import './styles.scss'
import './addonsStyles.scss'
import isSalesCenterSubDomain from 'utils/pivot/isSalesCenterSubDomain'
import applyRules from './controller/applyRules'
import updateDOM from './updateDOM'
import appStateUpdated from 'utils/appStateUpdated'
import saveToStorage from 'core/controllerPlans/saveToStorage'
const renderISC = isSalesCenterSubDomain()

const registry = [once(initDOM)]

if (renderISC) {
  registry.push(updateDOM, saveToStorage, appStateUpdated)
}

controller(config, registry, applyRules)
